import React from 'react';

import { Box, Text } from '@mantine/core';

type CalculatedExpectationCellProps = {
  value: number;
};

const CalculatedExpectationCell = ({ value }: CalculatedExpectationCellProps): JSX.Element => {
  const formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(2).replace(/\.?0+$/, '');

  return (
    <Box display='flex' sx={{ justifyContent: 'center' }}>
      <Text>{formattedValue} sessions</Text>
    </Box>
  );
};

export default CalculatedExpectationCell;
